import React from 'react';
import { Text, Box, Flex, Button } from "@radix-ui/themes";
import { useStore } from '../store/store';
import Icon from '@mdi/react';
import { mdiChartBar, mdiAccountGroup, mdiCurrencyUsd } from '@mdi/js';

const SidebarAnalytics = ({ onOpenScenesAnalytics, onOpenCharactersAnalytics, onOpenCostAnalytics }) => {
  const [state] = useStore();
  const novel = state.currentNovel;
  
  return (
    <Box p="2">     
      <Flex direction="column" gap="3">
        <Button 
          className="analytics-button"
          size="3" 
          style={{
            justifyContent: 'flex-start',
            backgroundColor: '#4b6a9a',
            width: '100%',
            cursor: 'pointer'
          }}
          onClick={onOpenScenesAnalytics}
        >
          <Icon path={mdiChartBar} size={1} />
          Scenes
        </Button>
        
        <Button 
          className="analytics-button"
          size="3"
          style={{
            justifyContent: 'flex-start',
            backgroundColor: '#6a4b9a',
            width: '100%',
            cursor: 'pointer'
          }}
          onClick={onOpenCharactersAnalytics}
        >
          <Icon path={mdiAccountGroup} size={1} />
          Characters
        </Button>
        
        <Button 
          className="analytics-button"
          size="3"
          style={{
            justifyContent: 'flex-start',
            backgroundColor: '#4b9a6a',
            width: '100%',
            cursor: 'pointer'
          }}
          onClick={onOpenCostAnalytics}
        >
          <Icon path={mdiCurrencyUsd} size={1} />
          Cost
        </Button>
        
        <Text size="2" style={{color: 'white', opacity: 0.8, marginTop: '10px'}}>
          Select an analytics view to see detailed insights about your novel.
        </Text>
      </Flex>
      
      <style jsx>{`
        .analytics-button {
          transition: transform 0.2s, box-shadow 0.2s;
        }
        
        .analytics-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </Box>
  );
};

export default SidebarAnalytics;
